// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3CY6s","logo":"header_logo__3Ih8b","icon":"header_icon__9Abx4","iconPrime":"header_iconPrime__29EvR","currentUser":"header_currentUser__2BpxO"};